/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import { Button, Card, FormControl, InputAdornment, InputLabel, MenuItem, Select, TextField, Tooltip } from "@mui/material";
import {
  Edit as EditIcon,
  Visibility as VisibilityIcon,
  ContentCopy as ContentCopyIcon,
  Download as DownloadIcon,
} from '@mui/icons-material';
import Grid from "@mui/material/Grid";
import RefreshIcon from "@mui/icons-material/Refresh";
import { GridSearchIcon } from "@mui/x-data-grid";
import axios from "axios";
import { BTable } from "components/BTable/BTable";
import { getColorMappings } from "components/ColorComponent/ColorComponent";
import TimelineItem from "components/Icon/TimelineItem";
import MDButton from "components/MDButton";
import DeleteModal from "components/deletemodal/deletemodal";
import BillingModal from "components/displayModel/billingModel";
import { useMaterialUIController } from "context";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import PageTitle from "examples/PageTitle/PageTitle";
import { useCallback, useEffect, useState } from "react";
import { createTheme } from "react-data-table-component";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import 'react-toastify/dist/ReactToastify.css';
import { appConstants } from "utils/appConstants";
import { getScreenRight, showResMsg } from "utils/generic";
import { genericMessage } from "utils/genericMessages";
import { deleteSelectedRCTI } from "utils/invoiceAPI";
import { getRCTI } from "utils/invoiceAPI";
import useFeatureAccess from "utils/useFeatureAccess";
import IconMenu from "components/CustomMaterialMenu/Custom";
import { loadingAction } from "ReduxReducers/loadingReducer";
import ShowSwalWithButtons from "components/SwalAlert/swalPopupWithButtons";
import useScreenAccess from "utils/getScreenAccessRight";
import { downloadRCTI } from "utils/invoiceAPI";
import SearchField from "components/SearchField/SearchField";
import DeleteIcon from '@mui/icons-material/Delete';
import LoadingModal from "components/LoadingModel/loadingModal";
import { Email as EmailIcon } from '@mui/icons-material';
import { AllKeysHaveValue } from "utils/generic";
import { getEmailAndTemplateForQuotation } from "utils/quotationAPI";
import { toast } from "react-toastify";
import EmailTemplateModal from "components/EmailModal/EmailTemplateModal";
import { resendEmailRcti } from "utils/invoiceAPI";
import select from "assets/theme/components/form/select";
import { formatCurrencyAUD } from "utils/formatCurrency";

createTheme(
  'solarized',
  {
    text: {
      primary: 'white',
      secondary: 'white',
    },
    background: {
      default: '#202940',
    },
    context: {
      background: '#202940',
      text: 'white',
    },
    divider: {
      default: 'white',
    },
    sortFocus: {
      default: '#2aa198',
    },
  },
  'dark',
);
createTheme(
  'light',
  {
    text: {
      primary: 'black',
      secondary: 'black',
    },
    background: {
      default: 'white',
    },
    context: {
      background: 'white',
      text: 'black',
    },
    divider: {
      default: 'gray',
    },
    //   button: {
    //     default: '#2aa198',
    //    hover: 'rgba(0,0,0,.08)',
    //    focus: 'rgba(255,255,255,.12)',
    //  disabled: 'rgba(255, 255, 255, .34)',
    // },
    sortFocus: {
      default: '#2aa198',
    },
  },
  'dark',
);

const SCREEN_NAME = "RCTI";
let SCREEN_RIGHT;

function InvoicesSearch() {
  const featureAccess = useFeatureAccess();
  const [resetClicked, setResetClicked] = useState(false);
  const currency = useSelector((state) => state.currency.currencySymbol);
  const navigate = useNavigate();
  const [deleteDialogeFlag, setDeleteDialogeFlag] = useState(false);
  const [deleteHeading, setDeleteHeading] = useState("");
  const [rows, setRows] = useState([]);
  const [totalRows, setTotalRows] = useState(0);
  const [perPage, setPerPage] = useState(20);
  const [selectedRows, setSelectedRows] = useState([]);
  const [title, setTitle] = useState("");
  const [controller] = useMaterialUIController();
  const { darkMode, sidenavColor } = controller;
  const { barColor, tableBorder } = getColorMappings(sidenavColor);
  const dispatch = useDispatch();
  const [loginDetails, setLoginDetails] = useState(JSON.parse(sessionStorage.getItem("LOGIN_DETAILS")));
  console.log("loginDetails", loginDetails)
  const [loading, setLoading] = useState(false);

  const [values, setValues] = useState({
    businessUserID: loginDetails?.businessUserID,
    sortingType: "",
    sortingField: "",
    rctiStatus: "All",
    durationDate: "",
    fromDate: "",
    toDate: "",
    page: 1,
    limit: 20,
    filterValues: "",
    searchParameterList: ['rctiStatus', 'rctiDate', 'dueDate', 'supplierName', 'rctiNumber', 'quotationNumber', 'finalAmount', 'supplierCompanyName', 'purchaseOrderNumber'],
  });
  const [showBillingModal, setShowBillingModal] = useState(false);
  const [screenAccess, setScreenAccess] = useState(false);

  const [open, setOpen] = useState(false);
  const [templateValues, setTemplateValues] = useState({
    screenType: "RCTI",
    userEmailAddress: '',
    customerEmailAddress: [],
    emailTemplate: ''
  });


  useEffect(() => {
    const fetchData = async () => {
      try {

        let sType = new URLSearchParams(window.location.search).get('rctiStatus');
        if (sType) {
          values.rctiStatus = sType;
        }

        let duration = new URLSearchParams(window.location.search).get('duration');
        let customFrom = new URLSearchParams(window.location.search).get('from');
        let customTo = new URLSearchParams(window.location.search).get('to');
        duration && (values.durationDate = duration)
        customFrom && (values.fromDate = customFrom)
        customTo && (values.toDate = customTo)
        sessionStorage.removeItem("HoldQuotationData");
        sessionStorage.removeItem("deletedItems");
        setLoginDetails(JSON.parse(sessionStorage.getItem("LOGIN_DETAILS")));
        await getRight();
        await fetchRCTI();
      } catch (error) {
        console.error("Error in useEffect:", error);
      }
    };
    fetchData();
  }, [values.rctiStatus, perPage]);


  async function getRight() {
    SCREEN_RIGHT = await getScreenRight(SCREEN_NAME);
    console.log("dfvjd", SCREEN_RIGHT)
    setScreenAccess(SCREEN_RIGHT === 'Full Access');
  }

  const fetchRCTI = async () => {
    values.perPage = perPage;
    values.token = loginDetails.token;
    getRCTI(values, (data) => {
      setRows(data.Result_Output.docs);
      setTotalRows(data.Result_Output.totalDocs);
    }, dispatch)

  }


  const handleCloneRCTI = async (id, RCTI_No) => {

    ShowSwalWithButtons(
      'Are you sure?', `Would you like to clone the RCTI ${RCTI_No}?`, 'warning', darkMode,
      () => {
        dispatch(loadingAction(true));
        let payload = { businessUserID: values.businessUserID, rctiID: id, userID: loginDetails?._id }
        axios.post(appConstants.baseURL + "invoice/cloneRCTI", payload,
          { headers: { Authorization: `Bearer ${sessionStorage.getItem("TOKEN")}` } }
        ).then(res => {
          console.log("response", res)
          dispatch(loadingAction(false));
          let status = res.data.Result_Status;
          if (res.data.Result_Output === "NO AVAILABLE CREDITS") {
            setShowBillingModal(true);
          } else {
            showResMsg(res.data.Result_Message, 2000, status, navigate, status === true ? `/rcti/edit/${res.data.Result_Output._id}` : "");
          }
        }).catch(error => {
          dispatch(loadingAction(false));
          console.log("Error in cloneInvoice", error);
        })
      }
    );

  }
  const handleSearchFilter = (event) => {
    setValues({ ...values, filterValues: event.target.value });
  };

  const handleSort = async (column, sortDirection) => {
    values.sortingField = column;
    values.sortingType = sortDirection;
    await fetchRCTI();
  };

  const handlePageChange = page => {
    values.page = page;
    fetchRCTI();
  };

  const handlePerRowsChange = async (newPerPage, page) => {
    values.page = page;
    values.limit = newPerPage;
    setPerPage(newPerPage);
  };

  const handleRowSelected = useCallback(state => {
    setSelectedRows(state.selectedRows);
    if (state.selectedRows.length > 0) {
      setTitle(" ");
    }
    else {
      setTitle("");
      setDeleteHeading("");
    }
  }, []);

  const handleDownload = async (s) => {

    await downloadRCTI({ _id: s }, async (response) => {

      const pdfContent = response.data;
      const binaryPdfData = atob(pdfContent);

      const arrayBuffer = new ArrayBuffer(binaryPdfData.length);
      const uint8Array = new Uint8Array(arrayBuffer);
      for (let i = 0; i < binaryPdfData.length; i++) {
        uint8Array[i] = binaryPdfData.charCodeAt(i);
      }
      const blob = new Blob([arrayBuffer], { type: 'application/pdf' });
      const url = URL.createObjectURL(blob);
      window.open(url, '_blank');
      ShowSwalWithButtons(
        '', `Would you like to download the Quotation?`, 'question', darkMode,
        () => {
          const link = document.createElement('a');
          link.href = url;
          link.download = 'quotation.pdf';
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
      );
      // Swal.fire({
      //   text: `Would you like to download the Quotation?`,
      //   icon: "question",
      //   showCancelButton: true,
      //   confirmButtonColor: "#4CAF50",
      //   cancelButtonColor: "#6c757d",
      //   confirmButtonText: "Yes",
      //   cancelButtonText: "No",
      //   reverseButtons: true,
      //   allowEnterKey: false, allowOutsideClick: false, allowEscapeKey: false,
      //   customClass: {
      //     popup: darkMode ? "darkPopup" : "whitePopup"
      //   }
      // }).then((result) => {
      //   if (result.isConfirmed) {
      //     const link = document.createElement('a');
      //     link.href = url;
      //     link.download = 'quotation.pdf';
      //     document.body.appendChild(link);
      //     link.click();
      //     document.body.removeChild(link);
      //   }
      // });

    }, dispatch)


  };

  const handleClose = (event, reason) => {
    if (reason && reason === "backdropClick") return;
    setOpen(false)
  }

  const handleSend = (templateData) => {
    console.log("templateData", templateData)

    const formdata = new FormData()
    formdata.append("selectedID", templateData.selectedID)
    formdata.append("userEmailAddress", templateData.userEmailAddress)
    formdata.append("customerEmailAddress", [...templateData.customerEmailAddress])
    formdata.append("emailTemplate", JSON.stringify({ ...templateData.emailTemplate }))
    formdata.append("sendMeCopy", templateData.sendMeCopy)
    formdata.append("file", templateData.uploadDocument)
    formdata.append("fileName", new Date());
    formdata.append("businessUserID", values.businessUserID);
    let payload = {
      selectedID: templateData.selectedID,
      userEmailAddress: templateData.userEmailAddress,
      customerEmailAddress: [...templateData.customerEmailAddress],
      emailTemplate: { ...templateData.emailTemplate },
      sendMeCopy: templateData.sendMeCopy,
      invoiceDoc: templateData.uploadDocument,
    };
    dispatch(loadingAction(true));
    resendEmailRcti(formdata, (data) => {
      let status = data.Result_Status;
      showResMsg(data.Result_Message, 2000, status);
      dispatch(loadingAction(true));
      fetchRCTI();
    }, dispatch);
    values.sendEmailFlag = true;
    values.templateValues = payload;
    setOpen(false)
  }

  const handleEmailQuotation = async (selectedRow) => {
    console.log("selected122", selectedRow)
    if (!selectedRow.finalAmount || selectedRow.finalAmount <= 0) {
      toast.error("No item added");
    } else {
      if (AllKeysHaveValue(templateValues)) {
        setOpen(true);
      } else {

        console.log("templateValuesR", templateValues)
        await getEmailAndTemplateForQuotation({
          screenType: templateValues.screenType, contactID: selectedRow.supplierID, selectedID: selectedRow._id, userID: sessionStorage.getItem("USER_ID").replaceAll('"', "")
        }, (data) => {
          console.log("datafdfd", data.Result_Output)
          if (data.Result_Status) {
            setTemplateValues(data.Result_Output);
            setOpen(true);
          } else {
            showResMsg(data.Result_Message, 2000, false);
            setOpen(false);
          }
        }, dispatch);
      }
    }

  }
  const handleEmailQuotationw = async (selectedRow) => {
    if (AllKeysHaveValue(templateValues)) {
      setOpen(true);
    } else {
      console.log("RAHUl", templateValues)
      console.log("selectedRow", selectedRow)
      await getEmailAndTemplateForQuotation({ screenType: templateValues.screenType, contactID: selectedRow.supplierID, userID: sessionStorage.getItem("USER_ID").replaceAll('"', "") }, (data) => {
        if (data.Result_Status) {
          console.log("data.Result_Output", data.Result_Output)
          setTemplateValues(data.Result_Output);
          setOpen(true);
        } else {
          showResMsg("Please try again! Something went wrong");
          setOpen(false);
        }
      }, dispatch);
    }
  }



  let columns = [
    {
      name: <p style={{ fontSize: "12px" }}>RCTI Number</p>,
      selector: row => (
        <div>
          <Tooltip title={`View & History ${row.rctiNumber}`}>
            <Link to={`/RCTI/view/${row._id}`} style={{ fontSize: "12px", color: tableBorder, fontWeight: '600' }}>
              <span className="textUnderline">{row.rctiNumber}</span></Link>
          </Tooltip>
        </div>

      ),
      sortable: true,
      sortField: 'rctiNumber',
    },
    {
      name: <p style={{ fontSize: "12px", textAlign: "left" }}>Supplier Name</p>,
      selector: row => (
        <span style={{ fontSize: "12px", textAlign: "left" }}>{row.supplierCompanyName}</span>
      ),
      sortable: true,
      sortField: 'supplierCompanyName',
      left: "true",
      style: { textAlign: "left" },
      minWidth: '150px'
    },
    {
      name: <p style={{ paddingLeft: "25px", fontSize: "12px" }}>RCTI Date</p>,
      selector: row => (
        <span style={{ fontSize: "12px" }}>{row.rctiDate}</span>
      ),
      sortable: true,
      sortField: 'rctiDate',
      center: "true",
    },
    {
      name: <p style={{ paddingLeft: "25px", fontSize: "12px" }}>Due Date</p>,
      selector: row => (
        <span style={{ fontSize: "12px", color: "#FF0000" }}>{row.dueDate}</span>
      ),
      sortable: true,
      sortField: 'dueDate',
      center: "true",
    },
    {
      name: <p style={{ paddingLeft: "0px", fontSize: "12px" }}>Reference Number</p>,
      selector: row => (
        <span style={{ fontSize: "12px" }}>{row.purchaseOrderNumber}</span>
      ),
      sortable: true,
      sortField: 'purchaseOrderNumber',
      left: 'true',
      minWidth: '100px'
    },
    // {
    //   name: <p style={{ paddingLeft: "25px", fontSize: "12px" }}>Status</p>,
    //   selector: row => (
    //     <span style={{ fontSize: "12px" }}>{row.rctiStatus}</span>
    //   ),
    //   sortable: true,
    //   sortField: 'rctiStatus',
    //   center: "true",
    // },
    {
      name: <p style={{ paddingLeft: "28px", fontSize: "12px" }}> Status</p>,
      selector: row => row.rctiStatus,
      sortable: true,
      sortField: "rctiStatus",
      center: true,
      cell: row => (
        <span
          style={{
            border: "1px solid black",
            color: "black",
            padding: "3px 3px",
            borderRadius: "2px",
            fontSize: "12px",
            fontWeight: 500,
            textTransform: "capitalize",
            display: "inline-block",
            minWidth: "60px",
            textAlign: "center",
          }}
        >
          {row.rctiStatus || "N/A"}
        </span>
      )
    },
    {
      name: <p style={{ paddingLeft: "40px", fontSize: "12px" }}>{`Amount (${currency})`}</p>,
      selector: row => (
        <span style={{ fontSize: "12px" }}>{formatCurrencyAUD(row.finalAmount)}</span>
      ),
      sortable: true,
      sortField: 'finalAmount',
      center: "true",
      minWidth: '100px'
    },
    {
      name: <p style={{ paddingLeft: "12px", fontSize: "12px" }}>Action(s)</p>,
      selector: row => (
        <span style={{ fontSize: "12px" }}>{row._id}</span>
      ),
      center: "true",
      style: { paddingLeft: "0px", paddingRight: "5px", minWidth: "12%" },
      cell: row => <IconMenu size="small" row={

        <>

          <Grid style={{ width: "100%" }}>
            {row.rctiStatus === "Unpaid" ?
              <Link to={`/rcti/edit/${row._id}`} disabled={!screenAccess}>
                <p style={darkMode ? { color: "white" } : { color: "black" }}>
                  <TimelineItem color="success"
                    icon={<EditIcon className="actionicon" />}
                    title="Edit" />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Edit</p>
              </Link>
              :
              <p style={darkMode ? { color: "white" } : { color: "black" }} disabled={!screenAccess}>
                <TimelineItem color="grey"
                  icon={<EditIcon className="actionicon" />}
                  title="Edit" style={{ cursor: "not-allowed" }} />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Edit</p>
            }
          </Grid>

          <Grid style={{ width: "100%" }}>
            <Link to={`/rcti/view/${row._id}`} >
              <p style={darkMode ? { color: "white" } : { color: "black" }}>
                <TimelineItem color="info"
                  icon={<VisibilityIcon className="actionicon" />}
                  title="View" />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;View</p>
            </Link>
          </Grid>

          <Grid style={{ width: "100%" }}>
            {/* <p style={darkMode ? { color: "white" } : { color: "black" }} disabled={!screenAccess} onClick={() => { handleDelete(row._id) }} > */}
            {row.rctiStatus === "Unpaid" ?
              <p style={darkMode ? { color: "white" } : { color: "black" }} disabled={!screenAccess} onClick={() => { handleDeleteDialogeClick(row._id) }} >
                <TimelineItem color="error"
                  icon={<DeleteIcon className="actionicon" />}
                  title="Delete" />
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Delete</p>
              :
              <p style={{ cursor: "not-allowed" }} disabled={!screenAccess}><TimelineItem color="grey"
                icon={<DeleteIcon className="actionicon" />}
                title="Delete" />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Delete</p>
            }
          </Grid>

          <Grid >
            {row.rctiStatus === "Unpaid" ?
              <p onClick={() => handleEmailQuotation(row)} disabled={!screenAccess}> <TimelineItem color="info"
                icon={<EmailIcon className="actionicon" />}
                title={row.emailSent > 0 ? "Resend Email" : "Send Email"} onClick={() => handleEmailQuotation(row)} />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{row.emailSent > 0 ? "Resend Email" : "Send Email"}</p>

              :
              <p style={{ cursor: "not-allowed" }} disabled={!screenAccess}><TimelineItem color="grey"
                icon={<EmailIcon className="actionicon" />}
                title="Resend Email" style={{ cursor: "not-allowed" }} />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Resend Email</p>

            }</Grid>

          <Grid style={{ width: "100%" }}>
            <p style={darkMode ? { color: "white" } : { color: "black" }} disabled={!screenAccess} onClick={() => { handleCloneRCTI(row._id, row.rctiNumber) }} >
              <TimelineItem color="warning"

                icon={<ContentCopyIcon className="actionicon" />}
                title=" Clone RCTI" onClick={() => { handleCloneRCTI(row._id, row.rctiNumber) }} />
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Clone RCTI</p>
          </Grid>
          {/* <Grid >
            <p onClick={() => { handleDownload(row._id) }} ><TimelineItem color="#87CEEB"
              icon={<DownloadIcon className="actionicon" />}
              title="Download Quotation" onClick={() => { handleDownload(row._id) }} />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Download RCTI</p>
          </Grid> */}
          <Grid style={{ width: "100%" }}>
            <Link to={`/rctis/rcti/${row.rctiNumber}/${row._id}?type=preview&download`} disabled={!screenAccess}>
              <p style={darkMode ? { color: "white" } : { color: "black" }} >
                <TimelineItem color="#87CEEB"
                  icon={<DownloadIcon className="actionicon" />}
                  title="Download Invoice"
                />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Preview/Download</p>
            </Link>
          </Grid>
        </>

      } />,
    },
  ];

  const handleDeleteDialogeClick = async (value) => {
    console.log("id", value);
    values._id = value;
    setDeleteDialogeFlag(!deleteDialogeFlag);
  };

  const handleCancel = (name) => (event) => {
    setDeleteDialogeFlag(false);
  };
  const handleDelete = async (id) => {
    deleteRCTI();
    setDeleteDialogeFlag(!deleteDialogeFlag);
  };

  const deleteRCTI = async () => {
    console.log("fffffvalues", values)
    try {
      setLoading(true);
      values.token = loginDetails.token;
      console.log("values.token", values.token)

      await axios
        .post(appConstants.baseURL + "invoice/deleteRCTI", values)
        .then((res) => {
          let response = res.data;
          console.log("response", response)
          if (response.Result_Status) {
            fetchRCTI();
            setTitle("");
            showResMsg(genericMessage.deleted, 1000, res.data.Result_Status);
            setLoading(false);
          } else {
            setLoading(false);
            showResMsg(response.Result_Message, 2000, false)
          }
        })
        .catch((error) => {
          setLoading(false);
          console.log("Error in deleteRCTI API=", error);
        });
    } catch (error) {
      console.log("Catch in deleteRCTI API=", error);
    }
  };

  const handleAddNew = () => {
    if (featureAccess) {
      if (SCREEN_RIGHT !== "Full Access") {
        showResMsg(genericMessage.notPermission, 2000, false);
      } else {
        navigate("/rcti/add?type=new");
      }
    }
    else {
      setShowBillingModal(true);
    }
  }
  const handleSearchInputValue = useCallback((searchInput) => {
    setValues(prevValues => ({ ...prevValues, filterValues: searchInput }));
  }, []);

  const getSearchResult = useCallback(() => {
    fetchRCTI();
  }, [values.filterValues]);
  useEffect(() => {
    // eslint-disable-next-line eqeqeq
    if (values.filterValues.length == "") {
      getSearchResult();

    }
  }, [values.filterValues]);


  const handleRefreshButtonClick = () => {
    // fetchQuotations();
    setValues((prevValues) => ({
      ...prevValues,
      sortingType: "",
      sortingField: "",
      rctiStatus: "All",
      activityStatus: "All",
      durationDate: "",
      fromDate: "",
      toDate: "",
      page: appConstants.page,
      limit: appConstants.limit,
      sendEmailFlag: false,
      businessUserID: loginDetails?.businessUserID,
      filterValues: "",

      searchParameterList: ['rctiStatus', 'rctiDate', 'dueDate', 'supplierName', 'rctiNumber', 'quotationNumber', 'finalAmount', 'supplierCompanyName', 'purchaseOrderNumber'],
    }));
    setResetClicked(true)
  }
  useEffect(() => {
    if (resetClicked) {
      fetchRCTI();
      setResetClicked(false);
    }

  }, [resetClicked]);
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <div style={{ marginTop: '20px' }}>
        <Card color="primary">
          <PageTitle screenName="RCTI" />
          <Grid container display={"flex"} justifyContent="end" mt={2.2} gap={2} >
            <MDButton
              rel="noreferrer"
              variant="gradient"
              color="success"
              style={{ height: "38.11px !important" }}
              // fullWidth
              onClick={handleRefreshButtonClick}

            >
              <RefreshIcon color="light" sx={{ cursor: "pointer" }} />
            </MDButton>
            <Grid item lg={1.5} xs={6} >
              <FormControl fullWidth>
                <InputLabel id="Status">Filter By Status</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  style={{ height: "38.11px" }}
                  label="Filter By Status"
                  value={values.rctiStatus}
                  onChange={(e) => setValues({ ...values, rctiStatus: e.target.value })}
                >
                  <MenuItem value="All">All</MenuItem>
                  <MenuItem value="Unpaid">Unpaid</MenuItem>
                  <MenuItem value="Paid">Paid</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid lg={2.5} xs={6}>
              <SearchField
                tableBorder={tableBorder}
                searchValue={values.filterValues}
                setSearchValue={handleSearchInputValue}
                getSearchResult={getSearchResult}
              />
              {/* <TextField
                type="text"
                variant="outlined"
                fullWidth
                className="searchButton"
                placeholder="Search..."
                label="Search Filter"
                value={values.filterValues}
                onChange={handleSearchFilter}
                onKeyUp={(e) => {
                  if (e.key === "Enter") fetchRCTI();
                }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment  >
                      <Button style={{ borderRadius: "0px 0.5rem  0.5rem 0px", boxShadow: "none", background: barColor }} variant="contained" onClick={fetchRCTI}>
                        <GridSearchIcon color="white" />
                      </Button>
                    </InputAdornment>
                  ),
                }}
              /> */}
            </Grid>
            <Grid style={{ marginRight: '16px' }}>
              <MDButton
                variant="contained"
                color="success"
                style={{ height: "38.11px" }}
                className={(!featureAccess || SCREEN_RIGHT !== "Full Access" ? (darkMode ? "disabledInDarkMode" : "disabledInLightMode") : "")}
                onClick={handleAddNew}
              >
                Add New
              </MDButton>
            </Grid>
            {/* <Grid>
              <div style={{ marginRight: '16px' }}>
                <MDButton
                  variant="contained"
                  color="warning"
                  style={{ height: "38.11px" }}
                  className={(!screenAccess ? (darkMode ? "disabledInDarkMode" : "disabledInLightMode") : "")}
                  onClick={handleAddNew}
                >
                  Show Statement
                </MDButton>
              </div>
            </Grid> */}

          </Grid>

          <BTable
            columns={columns}
            data={rows}
            sortingType={handleSort}
            sortServer
            pagination
            paginationServer
            paginationTotalRows={totalRows}
            onChangeRowsPerPage={handlePerRowsChange}
            onChangePage={handlePageChange}
            onSelectedRowsChange={handleRowSelected}
          />
        </Card>
      </div >

      <DeleteModal
        open={deleteDialogeFlag}
        handleDelete={handleDelete}
        handleCancel={handleCancel("handleCancel")}
        closeModalClick={handleCancel("closeModalClick")}
      />
      <BillingModal
        open={showBillingModal}
        handleConfirm={() => { navigate('/subscriptions') }}
        handleCancel={() => { setShowBillingModal(false) }}
        closeModalClick={() => { setShowBillingModal(false) }}
        message={genericMessage.billingMsg}
        title={genericMessage.noCreditAvailableTitle}
      />
      <LoadingModal loading={loading} />

      {open && <EmailTemplateModal
        open={open}
        handleClose={handleClose}
        templatesData={templateValues}
        onSend={handleSend}
      />}

    </DashboardLayout>
  );

}

export default InvoicesSearch;
